export function PortalLogin() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="w-full max-w-md p-8 bg-surface rounded-xl shadow-lg border border-border">
        <h1 className="text-2xl font-bold text-center text-primary mb-2">Patient Portal</h1>
        <p className="text-center text-text-muted mb-6">Access your medical records and appointments</p>
        <form className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Mobile Number</label>
            <input type="tel" className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary" placeholder="Enter registered mobile" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">OTP / Password</label>
            <input type="password" className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary" placeholder="Enter OTP or password" />
          </div>
          <button type="submit" className="w-full py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors">Sign In</button>
        </form>
      </div>
    </div>
  )
}
